import React from 'react'
import classNames from 'classnames'

const Th = ({ highlighted = false, className = '', ...props }) => (
  <th
    scope="col"
    className={classNames([
      'whitespace-nowrap',
      'sticky',
      'z-30',
      'top-0',
      'bg-gray-50',
      'hover:bg-gray-100',
      'px-1',
      'md:px-2',
      'xl:px-4',
      'py-2',
      'xl:py-3',
      'text-xs',
      'font-medium',
      'uppercase',
      'tracking-wider',
      'text-left',
      'truncate',
    ], {
      'text-gray-800': highlighted,
      'text-gray-600': !highlighted,
    }, className)}
    {...props}
  />
)

const Table = ({ children, className = '' }) => (
  <table className={classNames('overflow-scroll relative table w-full', className)}>
    { children }
  </table>
)

const Thead = (props) => (
  <thead {...props} />
)

const Tbody = (props) => (
  <tbody {...props} />
)

const Td = ({ children, className, ...props }) => (
  <td
    className={classNames('px-1 xl:px-4 py-2 xl:py-3 whitespace-nowrap text-sm', className)}
    title={Array.isArray(children) ? undefined : (React.isValidElement(children) ? undefined : children)}
    children={children}
    {...props}
  />
)

const Tr = ({ className, ...props }) => (
  <tr
    className={classNames('py-2 hover:bg-gray-100 border-b border-gray-100', className)}
    tabIndex={0}
    {...props}
  />
)

export const components = {
  Table,
  Thead,
  Tbody,
  Th,
  Tr,
  Td,
}

export default components
